export const API_BASE = {
  localhost: 'https://user-api-dev.bostonglobe.com',
  sandbox: 'https://user-api-dev.bostonglobe.com',
  prod: 'https://user-api.bostonglobe.com',
};
export const SUBDOMAIN = {
  localhost: 'localhost',
  sandbox: 'arc-sandbox',
  prod: 'www',
};

export const SUBDOMAIN_PIANO_LOGIN = {
  localhost: 'localhost',
  sandbox: 'arc-sandbox',
  prod: 'www',
};

export const LOGIN_PAGE = {
  localhost: 'http://local-login.bostonglobe.com:3000/',
  sandbox: 'https://pages-sandbox.bostonglobe.com/login/',
  prod: 'https://pages.bostonglobe.com/login/',
};

export const FORGOT_PASSWORD_PAGE = {
  localhost: 'http://local-login.bostonglobe.com:3000/forgot-password',
  sandbox: 'https://pages-sandbox.bostonglobe.com/login/forgot-password',
  prod: 'https://pages.bostonglobe.com/login/forgot-password',
};

const memberCenterSubdomain = (process.env.REACT_APP_ENVIRONMENT === 'prod') ? 'manage' : 'manage-qa';
const homepageSubdomain = SUBDOMAIN[process.env.REACT_APP_ENVIRONMENT];

export const CONTACT = 'https://customerservice.bostonglobe.com/hc/en-us';
export const SUBSCRIBE_URL = 'https://subscribe.bostonglobe.com';
export const ONE_CLICK_REPURCHASE = `https://${memberCenterSubdomain}.bostonglobe.com/cs/mc/oclogin.aspx`;
export const MEMBER_CENTER = `https://${memberCenterSubdomain}.bostonglobe.com/cs/mc/login.aspx`;
export const ARCHIVE_URL = `https://www.tkqlhce.com/click-8819575-11570746?url=${encodeURIComponent('https://bostonglobe.newspapers.com/?xid=1880&tpa=')}`;
export const GLOBE_URL = `https://${homepageSubdomain}.bostonglobe.com/`;
